import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import Spinner from 'react-spinkit'

const Icon = (props) => {
  return props.busy
    ? (
      <Spinner
        noFadeIn
        spinnerName="circle"
      />
    )
    : <i className={`glyphicon glyphicon-${props.icon}`} />
}

Icon.propTypes = {
  busy: PropTypes.bool,
  icon: PropTypes.string,
}

export default class Button extends Component {

  static propTypes = {
    busy: PropTypes.bool,
    children: PropTypes.node,
    confirmation: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    onClick: PropTypes.func
  }

  @autobind
  handleClick(e) {
    const { confirmation } = this.props
    // eslint-disable-next-line
    if (!confirmation || window.confirm(confirmation)) {
      if (this.props.onClick) {
        this.props.onClick(e)
      }
    }
  }

  render() {

    const {
      icon, busy, children, disabled, confirmation
    } = this.props

    const nonButtonProps = ['icon', 'busy', 'children', 'confirmation']

    const hasIcon = icon || busy
    const isDisabled = disabled || busy

    const buttonProps = Object.keys(this.props)
      .filter((prop) => nonButtonProps.indexOf(prop) === -1)
      .reduce((memo, key) => {
        memo[key] = this.props[key]
        return memo
      }, {})

    buttonProps.disabled = isDisabled

    if (confirmation) {
      buttonProps.onClick = this.handleClick
    }

    return (
      <button
        {...buttonProps}
      >

        {hasIcon
          ? (
            <Icon
              icon={icon}
              busy={busy}
            />
          )
          : null}
        {hasIcon ? <span>&nbsp;</span> : null}
        {children}
      </button>
    )

  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Button.js